'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UITextArea from 'UIComponents/input/UITextArea';
import { DeprecatedReportReviewReasons, Reportables, ReportReviewReasons, ReportReplyReasons } from 'marketplace-ui-reviews/constants/ReportReasons';
import BaseReviewModal from './BaseReviewModal';
const textPath = 'ecosystemMarketplaceCore.reviews.modal.report';
/** @deprecated use ReportReviewModal.tsx in marketplace-ui-reviews once your app is using the records from marketplace-ui-reviews */

const ReportReviewModal = props => {
  const [reason, setReason] = useState(null);
  const [comment, setComment] = useState('');
  const reasonOptions = useMemo(() => {
    const filteredReportReviewReasons = Object.entries(ReportReviewReasons).reduce((acc, [key, value]) => {
      if (DeprecatedReportReviewReasons.includes(key)) return acc;
      acc[key] = value;
      return acc;
    }, {});
    const reasons = props.type === Reportables.REVIEW ? filteredReportReviewReasons : ReportReplyReasons;
    return Object.values(reasons).map(opt => {
      return {
        text: unescapedText(`ecosystemMarketplaceCore.reviews.reportReasons.${props.type}.${opt}.description`),
        value: opt
      };
    });
  }, [props.type]);
  const form = useMemo(() => {
    return /*#__PURE__*/_jsxs(UIForm, {
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        required: true,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${textPath}.reason`
        }),
        children: /*#__PURE__*/_jsx(UISelect, {
          onChange: ({
            target: {
              value
            }
          }) => setReason(value),
          options: reasonOptions,
          value: reason,
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${textPath}.reasonPlaceholder`
          })
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        required: true,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${textPath}.comment`
        }),
        children: /*#__PURE__*/_jsx(UITextArea, {
          placeholder: unescapedText(`${textPath}.commentPlaceholder`),
          value: comment,
          onChange: ({
            target: {
              value
            }
          }) => setComment(value),
          rows: 6
        })
      })]
    });
  }, [comment, reason, reasonOptions]);
  return /*#__PURE__*/_jsx(BaseReviewModal, Object.assign({}, props, {
    form: form,
    confirmDisabled: !reason || !comment,
    onConfirm: () => props.onConfirm(reason, comment),
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${textPath}.tooltip`
    })
  }));
};

const _BaseReviewModal$prop = BaseReviewModal.propTypes,
      baseProps = _objectWithoutPropertiesLoose(_BaseReviewModal$prop, ["form"]);

ReportReviewModal.propTypes = Object.assign({}, baseProps, {
  type: PropTypes.oneOf(Object.keys(Reportables))
});
ReportReviewModal.defaultProps = {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `${textPath}.title`
  }),
  type: Reportables.REVIEW
};
export default ReportReviewModal;